import { createSlice } from '@reduxjs/toolkit';

import type {
  Area,
  Point,
  Asset,
  Entry,
  Settings,
} from 'src/data';

import {
  areas,
  points,
  assets,
  settings,
} from 'src/data';


export interface ContentfulState {
  points: Record<string, Point>;
  areas: Record<string, Area>;
  areasList: Area[];
  assets: Record<string, Asset>;
  settings: Settings;
}

const initialState: ContentfulState = {
  points: points.reduce(toObject, {}),
  areas: areas.reduce(toObject, {}),
  areasList: areas,
  assets: assets.reduce(toObject, {}),
  settings,
};

function toObject<T extends Entry | Asset>(obj: Record<string, T>, instance: T): Record<string, T> {
  obj[instance.sys.id] = instance;
  return obj;
}

export const contentfulSlice = createSlice({
  name: 'contentful',
  initialState,
  reducers: {},
});

export const contentfulReducer = contentfulSlice.reducer;
